/* global EmblaCarousel, YT */
const players = [];

// -------------------- Dots --------------------
const setupEmblaDotBtns = (dotsArray, embla) => {
  dotsArray.forEach((dotNode, i) => {
    dotNode.addEventListener("click", () => embla.scrollTo(i), false);
    dotNode.addEventListener("keypress", (e) => {
      if (e.key === "Enter") embla.scrollTo(i);
    });
  });
};

const generateEmblaDotBtns = (dots, embla) => {
  const template = document.getElementById("embla-dot-section").innerHTML;
  dots.innerHTML = embla.scrollSnapList().reduce((acc) => acc + template, "");
  return [].slice.call(dots.querySelectorAll(".featured-embla__dot"));
};

const selectEmblaDotBtn = (dotsArray, embla) => () => {
  const previous = embla.previousScrollSnap();
  const selected = embla.selectedScrollSnap();
  const totalSlides = dotsArray.length;

  dotsArray[previous].setAttribute("aria-pressed", false);
  dotsArray[previous].classList.remove("is-selected");

  dotsArray[selected].classList.add("is-selected");
  dotsArray[selected].setAttribute("aria-pressed", true);
  dotsArray[selected].setAttribute(
    "title",
    `Slide ${selected + 1} of ${totalSlides}`
  );
};

// -------------------- Thumbnails --------------------
const onThumbClick = (mainCarousel, index) => () => {
  mainCarousel.scrollTo(index);
};

const selectThumbBtn = (mainCarousel, thumbCarousel) => {
  const previous = mainCarousel.previousScrollSnap();
  const selected = mainCarousel.selectedScrollSnap();

  mainCarousel.slideNodes()[previous].classList.remove("is-selected");
  mainCarousel.slideNodes()[selected].classList.add("is-selected");

  thumbCarousel.slideNodes()[previous].classList.remove("is-selected");
  thumbCarousel.slideNodes()[selected].classList.add("is-selected");

  pauseVideo();
  playVideo();
};

const followMainCarousel = (mainCarousel, thumbCarousel) => () => {
  thumbCarousel.scrollTo(mainCarousel.selectedScrollSnap());
  selectThumbBtn(mainCarousel, thumbCarousel);
};

// -------------------- Video Logic --------------------
const pauseVideo = () => {
  const htmlVideoPlayers = document.querySelectorAll(
    ".product-single__media video"
  );

  htmlVideoPlayers.forEach((player) => {
    player.pause();
  });

  players.forEach((player) => {
    player.pauseVideo();
  });
};

const playVideo = () => {
  const selectedMedia = document.querySelector(
    ".is-selected .product-single__media"
  );
  const selectedHtmlVideo = selectedMedia?.querySelector("video");

  if (selectedMedia) {
    const { videoHost, videoId } = selectedMedia.dataset;

    if (videoHost === "youtube") {
      players.forEach((player) => {
        if (player.playerInfo.videoData.video_id === videoId) {
          player.playVideo();
          player.unMute();
        }
      });
    }

    if (selectedHtmlVideo) selectedHtmlVideo.play();
  }
};

const onPlayerReady = (event) => {
  event.target.mute();
};

function initializeYoutubeMedia() {
  const productMediaWrapper = document.querySelectorAll(".product-single__media");

  productMediaWrapper.forEach((media) => {
    const { videoHost, videoId } = media.dataset;

    if (videoHost === "youtube") {
      const iframe = media.querySelector("iframe");
      const newPlayer = new YT.Player(iframe, {
        playerVars: { autoplay: 1, playsinline: 1 },
        videoId,
        events: {
          onReady: onPlayerReady,
        },
      });

      players.push(newPlayer);
    }
  });
}

// -------------------- Prev / Next --------------------
const setupPrevNextBtns = (prevBtn, nextBtn, embla) => {
  prevBtn.addEventListener("click", embla.scrollPrev, false);
  nextBtn.addEventListener("click", embla.scrollNext, false);
};

const disablePrevNextBtns = (prevBtn, nextBtn, embla) => {
  return () => {
    if (embla.canScrollPrev()) prevBtn.removeAttribute("disabled");
    else prevBtn.setAttribute("disabled", "disabled");

    if (embla.canScrollNext()) nextBtn.removeAttribute("disabled");
    else nextBtn.setAttribute("disabled", "disabled");
  };
};

// -------------------- Initialize --------------------
const EmblaInitialize = () => {
  const options = {
      loop: false,
      skipSnaps: false,
      containScroll: 'trimSnaps',
      align: 'start',
      startIndex: 0,
      slidesToScroll: 1,
      draggable: true,
      dragFree: false,
    };
  const mainCarouselWrap = document.getElementById("main-carousel");
  const mainCarouselView = mainCarouselWrap.querySelector(".embla__viewport");
  const dots = document.querySelector(".featured-embla__dots");

  const mainCarousel = new EmblaCarousel(mainCarouselView, options);

  const dotsArray = generateEmblaDotBtns(dots, mainCarousel);
  const setSelectedDotBtn = selectEmblaDotBtn(dotsArray, mainCarousel);

  setupEmblaDotBtns(dotsArray, mainCarousel);
  mainCarousel.on("select", setSelectedDotBtn);
  mainCarousel.on("init", setSelectedDotBtn);

  const prevBtn = mainCarouselWrap.querySelector(".embla__button--prev");
  const nextBtn = mainCarouselWrap.querySelector(".embla__button--next");

  const disablePrevAndNextBtns = disablePrevNextBtns(
    prevBtn,
    nextBtn,
    mainCarousel
  );
  setupPrevNextBtns(prevBtn, nextBtn, mainCarousel);
  mainCarousel.on("select", disablePrevAndNextBtns);
  mainCarousel.on("init", disablePrevAndNextBtns);

  const thumbCarouselWrap = document.getElementById("thumb-carousel");
  const thumbCarouselView = thumbCarouselWrap?.querySelector(".embla__viewport");

  if (thumbCarouselView) {
    const thumbCarousel = new EmblaCarousel(thumbCarouselView, {
        selectedClass: 'is-selected',
        containScroll: 'keepSnaps',
        dragFree: false,
        loop: false,
        axis: 'y',
      });

    thumbCarousel.slideNodes().forEach((thumbNode, index) => {
      const onClick = onThumbClick(mainCarousel, index);
      thumbNode.addEventListener("click", onClick, false);
    });

    const syncThumbCarousel = followMainCarousel(mainCarousel, thumbCarousel);
    mainCarousel.on("select", syncThumbCarousel);
    thumbCarousel.on("init", syncThumbCarousel);
  }
};

// -------------------- Boot --------------------
if (document.querySelectorAll(".product__media-wrapper").length > 0) {
  window.onYouTubePlayerAPIReady = () => {
    initializeYoutubeMedia();
  };
}

EmblaInitialize();
